import axios from "axios";
import router from "../router/index";

const api = axios.create({
    baseURL: "../epsmarc",
    //baseURL: "http://172.28.43.190:8080/epsmarc"
    headers: {
        "Content-type": "application/json"
    }
});

api.interceptors.request.use(config => {
    const token = localStorage.getItem('jwt');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});


function createAxiosResponseInterceptor() {
    const interceptor = api.interceptors.response.use(
        (response) => response,
        (responseError) => {

            if (responseError.response.status !== 401) {
                return Promise.reject(responseError);
            }
            //interceptor must be ejected temporarily because if the refresh token response is also 401, it would cause infinite loop
            api.interceptors.response.eject(interceptor);

            return api.post('/security/jwt/refresh', { jwt: localStorage.getItem("jwt") })
                .then((response) => {

                    localStorage.setItem('jwt', response.data.jwt);
                    responseError.response.config.headers["Authorization"] =
                        "Bearer " + response.data.access_token;
                    return api(responseError.response.config);
                })
                .catch((refreshError) => {
                    localStorage.removeItem("jwt");
                    router.push("/");
                    return Promise.reject(refreshError);
                })
                .finally(createAxiosResponseInterceptor); // Re-attach the interceptor by running the method
        }
    );
}
createAxiosResponseInterceptor();

export default api;



